export type QuestionReviewStatus = 0 | 1 | null;

// Status presentation is intentionally separate from response mutation and permission state.
export function resolveQuestionReviewStatusLabel(
    status: QuestionReviewStatus,
    isPending: boolean
): string {
    if (isPending) {
        return "";
    }

    return status === 1 ? "Reviewed" : "Needs Review";
}

export function resolveQuestionReviewStatusClass(
    status: QuestionReviewStatus,
    isPending: boolean
): string {
    if (isPending) {
        return "saq-question__status-indicator--pending";
    }

    return status === 1
        ? "saq-question__status-indicator--compliant"
        : "saq-question__status-indicator--not-compliant";
}
